/* eslint-disable react/prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SINGLE_DEALER_ROOT } from '../../../lib/data-service';
import { formatDistance } from '../../../lib/utils';
import { useConfig, useMap, useDeviceType } from '../../../hooks';

import Icon from '../../Icon';

function ListItem ({ dealer, location, dealerLoading, onActiveDealerChange }) {
  const { config } = useConfig();
  const { map } = useMap();
  const { isMobile } = useDeviceType();
  const { t } = useTranslation('dealers');

  const distance = formatDistance(dealer.distance, config.distanceUnit);
  const isNad = !!dealer.company_types.find(ct => ct.type === 'nokian');
  const isNadNA = !!dealer.company_types.find(ct => ct.type === 'nadna');
  let logo = '';
  let logoAlt = '';
  if (isNad) {
    logo = 'https://nokiantyres.studio.crasman.cloud/pub/web/assets/NAD-logo.png';
    logoAlt = t('Nokian Authorized Dealer');
  }
  else if (isNadNA) {
    logo = 'https://nokiantyres.studio.crasman.cloud/pub/Car%20and%20Van%20Tyres/Nokian%20Tyres%20Authorized%20Dealers/Logos/Nokian_Tyres_Affiliated_Dealer_RGB_cropped.png';
    logoAlt = t('Nokian Affiliated Dealer');
  }

  const stockStatusMap = {
    InStock: {
      label: t('In stock'),
    },
    LimitedAvailability: {
      label: t('Limited availability'),
    },
    OutOfStock: {
      label: t('Out of stock'),
    },
  };
  const availability = dealer.products?.stockStatus ? stockStatusMap[dealer.products.stockStatus]?.label : null;

  let className = `dealer${isNad ? ' nt' : ''}${isNadNA ? ' affiliated' : ''}`;

  if (dealerLoading) {
    className += ' loading';
  }

  //NTCONT-976 Japan wants different address formatting
  const isJp = document.body.dataset.language === 'jp_JP';

  const dealerFields1 = config.addressFields.filter(
    field => isJp && field === 'zipcode' && dealer[field] !== ''
  );

  const dealerFields2 = config.addressFields.filter(
    field => (!isJp || isJp && field !== 'zipcode') && dealer[field] !== ''
  );

  const address = dealerFields1
    .map((field, fieldIndex) => (dealer[field] !== '' ? dealer[field] : false))
    .filter(Boolean)
    .join(!isJp ? ', ' : '');

  const address2 = dealerFields2
    .map((field, fieldIndex) => (dealer[field] !== '' ? dealer[field] : false))
    .filter(Boolean)
    .join(!isJp ? ', ' : '');

  function handleHover() {
    const marker = map?.getMarker(dealer.uuid);
    if (marker) {
      marker.setMarkerType('hover');
    }
  }

  function handleHoverOut() {
    const marker = map?.getMarker(dealer.uuid);
    if (marker) {
      marker.setMarkerType('default');
    }
  }

  return (
    <a
      href={`${SINGLE_DEALER_ROOT}${dealer.slug}/`}
      className={className}
      onMouseEnter={handleHover}
      onMouseLeave={handleHoverOut}
      onClick={(e) => {
        e.preventDefault();
        onActiveDealerChange(dealer);
      }}
      data-dealer={dealer.uuid}
    >
      <Icon icon={dealer.marker.inactive} alt={dealer.company_name} />

      <article className="details">
        <h4>{config.reorderCompanyName && dealer.nameReorderable ? (dealer.company_name_extra || dealer.company_name) : dealer.company_name}</h4>
        <address className="address">
          <p>{address}</p>
          <p>{address2}</p>
        </address>
        <span className="link-wrapper">
          <span className="link">{t('Show details')}</span> &rsaquo;
        </span>
      </article>

      <div className="distance">
        {distance && ['user_location', 'user_search', 'address'].includes(location.type) && (
          <p>
            {distance} {t('du')}
          </p>
        )}
        {!isMobile && logo && (
          <img className="dealer-type-logo" src={logo} alt={logoAlt} />
        )}
        {availability && (
          <div className={'dealer-purchase-tyre__stock-status dealer-purchase-tyre__stock-status--' + dealer.products.stockStatus}>
          <p><span className="icon icon--tyre"></span>{availability}</p>
          </div>
        )}
      </div>

      {isMobile && logo && (
        <div className="logos">
          {logo && (
            <img className="dealer-type-logo" src={logo} alt={logoAlt} />
          )}
        </div>
      )}
    </a>
  );
}



export default ListItem;
